module.exports = __webpack_public_path__ + "1.0.0-fa265927/img/offline-database-2.f8a932a2.svg";